/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as Char123LocaleChar125IndexRouteImport } from './routes/{-$locale}/index'
import { Route as Char123LocaleChar125JobOffersRouteRouteImport } from './routes/{-$locale}/job-offers/route'
import { Route as Char123LocaleChar125InternshipsRouteRouteImport } from './routes/{-$locale}/internships/route'
import { Route as Char123LocaleChar125RatingsIndexRouteImport } from './routes/{-$locale}/ratings/index'
import { Route as Char123LocaleChar125JobOffersIndexRouteImport } from './routes/{-$locale}/job-offers/index'
import { Route as Char123LocaleChar125InternshipsIndexRouteImport } from './routes/{-$locale}/internships/index'
import { Route as Char123LocaleChar125HospitalsIndexRouteImport } from './routes/{-$locale}/hospitals/index'
import { Route as Char123LocaleChar125EventsIndexRouteImport } from './routes/{-$locale}/events/index'
import { Route as Char123LocaleChar125ArticlesIndexRouteImport } from './routes/{-$locale}/articles/index'
import { Route as Char123LocaleChar125JobOffersIdRouteImport } from './routes/{-$locale}/job-offers/$id'
import { Route as Char123LocaleChar125InternshipsIdRouteImport } from './routes/{-$locale}/internships/$id'

const Char123LocaleChar125IndexRoute =
  Char123LocaleChar125IndexRouteImport.update({
    id: '/{-$locale}/',
    path: '/{-$locale}/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Char123LocaleChar125JobOffersRouteRoute =
  Char123LocaleChar125JobOffersRouteRouteImport.update({
    id: '/{-$locale}/job-offers',
    path: '/{-$locale}/job-offers',
    getParentRoute: () => rootRouteImport,
  } as any)
const Char123LocaleChar125InternshipsRouteRoute =
  Char123LocaleChar125InternshipsRouteRouteImport.update({
    id: '/{-$locale}/internships',
    path: '/{-$locale}/internships',
    getParentRoute: () => rootRouteImport,
  } as any)
const Char123LocaleChar125RatingsIndexRoute =
  Char123LocaleChar125RatingsIndexRouteImport.update({
    id: '/{-$locale}/ratings/',
    path: '/{-$locale}/ratings/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Char123LocaleChar125JobOffersIndexRoute =
  Char123LocaleChar125JobOffersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => Char123LocaleChar125JobOffersRouteRoute,
  } as any)
const Char123LocaleChar125InternshipsIndexRoute =
  Char123LocaleChar125InternshipsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => Char123LocaleChar125InternshipsRouteRoute,
  } as any)
const Char123LocaleChar125HospitalsIndexRoute =
  Char123LocaleChar125HospitalsIndexRouteImport.update({
    id: '/{-$locale}/hospitals/',
    path: '/{-$locale}/hospitals/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Char123LocaleChar125EventsIndexRoute =
  Char123LocaleChar125EventsIndexRouteImport.update({
    id: '/{-$locale}/events/',
    path: '/{-$locale}/events/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Char123LocaleChar125ArticlesIndexRoute =
  Char123LocaleChar125ArticlesIndexRouteImport.update({
    id: '/{-$locale}/articles/',
    path: '/{-$locale}/articles/',
    getParentRoute: () => rootRouteImport,
  } as any)
const Char123LocaleChar125JobOffersIdRoute =
  Char123LocaleChar125JobOffersIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => Char123LocaleChar125JobOffersRouteRoute,
  } as any)
const Char123LocaleChar125InternshipsIdRoute =
  Char123LocaleChar125InternshipsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => Char123LocaleChar125InternshipsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/{-$locale}/internships': typeof Char123LocaleChar125InternshipsRouteRouteWithChildren
  '/{-$locale}/job-offers': typeof Char123LocaleChar125JobOffersRouteRouteWithChildren
  '/{-$locale}/': typeof Char123LocaleChar125IndexRoute
  '/{-$locale}/internships/$id': typeof Char123LocaleChar125InternshipsIdRoute
  '/{-$locale}/job-offers/$id': typeof Char123LocaleChar125JobOffersIdRoute
  '/{-$locale}/articles/': typeof Char123LocaleChar125ArticlesIndexRoute
  '/{-$locale}/events/': typeof Char123LocaleChar125EventsIndexRoute
  '/{-$locale}/hospitals/': typeof Char123LocaleChar125HospitalsIndexRoute
  '/{-$locale}/internships/': typeof Char123LocaleChar125InternshipsIndexRoute
  '/{-$locale}/job-offers/': typeof Char123LocaleChar125JobOffersIndexRoute
  '/{-$locale}/ratings/': typeof Char123LocaleChar125RatingsIndexRoute
}
export interface FileRoutesByTo {
  '/{-$locale}': typeof Char123LocaleChar125IndexRoute
  '/{-$locale}/internships/$id': typeof Char123LocaleChar125InternshipsIdRoute
  '/{-$locale}/job-offers/$id': typeof Char123LocaleChar125JobOffersIdRoute
  '/{-$locale}/articles': typeof Char123LocaleChar125ArticlesIndexRoute
  '/{-$locale}/events': typeof Char123LocaleChar125EventsIndexRoute
  '/{-$locale}/hospitals': typeof Char123LocaleChar125HospitalsIndexRoute
  '/{-$locale}/internships': typeof Char123LocaleChar125InternshipsIndexRoute
  '/{-$locale}/job-offers': typeof Char123LocaleChar125JobOffersIndexRoute
  '/{-$locale}/ratings': typeof Char123LocaleChar125RatingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/{-$locale}/internships': typeof Char123LocaleChar125InternshipsRouteRouteWithChildren
  '/{-$locale}/job-offers': typeof Char123LocaleChar125JobOffersRouteRouteWithChildren
  '/{-$locale}/': typeof Char123LocaleChar125IndexRoute
  '/{-$locale}/internships/$id': typeof Char123LocaleChar125InternshipsIdRoute
  '/{-$locale}/job-offers/$id': typeof Char123LocaleChar125JobOffersIdRoute
  '/{-$locale}/articles/': typeof Char123LocaleChar125ArticlesIndexRoute
  '/{-$locale}/events/': typeof Char123LocaleChar125EventsIndexRoute
  '/{-$locale}/hospitals/': typeof Char123LocaleChar125HospitalsIndexRoute
  '/{-$locale}/internships/': typeof Char123LocaleChar125InternshipsIndexRoute
  '/{-$locale}/job-offers/': typeof Char123LocaleChar125JobOffersIndexRoute
  '/{-$locale}/ratings/': typeof Char123LocaleChar125RatingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/{-$locale}/internships'
    | '/{-$locale}/job-offers'
    | '/{-$locale}/'
    | '/{-$locale}/internships/$id'
    | '/{-$locale}/job-offers/$id'
    | '/{-$locale}/articles/'
    | '/{-$locale}/events/'
    | '/{-$locale}/hospitals/'
    | '/{-$locale}/internships/'
    | '/{-$locale}/job-offers/'
    | '/{-$locale}/ratings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/{-$locale}'
    | '/{-$locale}/internships/$id'
    | '/{-$locale}/job-offers/$id'
    | '/{-$locale}/articles'
    | '/{-$locale}/events'
    | '/{-$locale}/hospitals'
    | '/{-$locale}/internships'
    | '/{-$locale}/job-offers'
    | '/{-$locale}/ratings'
  id:
    | '__root__'
    | '/{-$locale}/internships'
    | '/{-$locale}/job-offers'
    | '/{-$locale}/'
    | '/{-$locale}/internships/$id'
    | '/{-$locale}/job-offers/$id'
    | '/{-$locale}/articles/'
    | '/{-$locale}/events/'
    | '/{-$locale}/hospitals/'
    | '/{-$locale}/internships/'
    | '/{-$locale}/job-offers/'
    | '/{-$locale}/ratings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  Char123LocaleChar125InternshipsRouteRoute: typeof Char123LocaleChar125InternshipsRouteRouteWithChildren
  Char123LocaleChar125JobOffersRouteRoute: typeof Char123LocaleChar125JobOffersRouteRouteWithChildren
  Char123LocaleChar125IndexRoute: typeof Char123LocaleChar125IndexRoute
  Char123LocaleChar125ArticlesIndexRoute: typeof Char123LocaleChar125ArticlesIndexRoute
  Char123LocaleChar125EventsIndexRoute: typeof Char123LocaleChar125EventsIndexRoute
  Char123LocaleChar125HospitalsIndexRoute: typeof Char123LocaleChar125HospitalsIndexRoute
  Char123LocaleChar125RatingsIndexRoute: typeof Char123LocaleChar125RatingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/{-$locale}/': {
      id: '/{-$locale}/'
      path: '/{-$locale}'
      fullPath: '/{-$locale}/'
      preLoaderRoute: typeof Char123LocaleChar125IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/{-$locale}/job-offers': {
      id: '/{-$locale}/job-offers'
      path: '/{-$locale}/job-offers'
      fullPath: '/{-$locale}/job-offers'
      preLoaderRoute: typeof Char123LocaleChar125JobOffersRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/{-$locale}/internships': {
      id: '/{-$locale}/internships'
      path: '/{-$locale}/internships'
      fullPath: '/{-$locale}/internships'
      preLoaderRoute: typeof Char123LocaleChar125InternshipsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/{-$locale}/ratings/': {
      id: '/{-$locale}/ratings/'
      path: '/{-$locale}/ratings'
      fullPath: '/{-$locale}/ratings/'
      preLoaderRoute: typeof Char123LocaleChar125RatingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/{-$locale}/job-offers/': {
      id: '/{-$locale}/job-offers/'
      path: '/'
      fullPath: '/{-$locale}/job-offers/'
      preLoaderRoute: typeof Char123LocaleChar125JobOffersIndexRouteImport
      parentRoute: typeof Char123LocaleChar125JobOffersRouteRoute
    }
    '/{-$locale}/internships/': {
      id: '/{-$locale}/internships/'
      path: '/'
      fullPath: '/{-$locale}/internships/'
      preLoaderRoute: typeof Char123LocaleChar125InternshipsIndexRouteImport
      parentRoute: typeof Char123LocaleChar125InternshipsRouteRoute
    }
    '/{-$locale}/hospitals/': {
      id: '/{-$locale}/hospitals/'
      path: '/{-$locale}/hospitals'
      fullPath: '/{-$locale}/hospitals/'
      preLoaderRoute: typeof Char123LocaleChar125HospitalsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/{-$locale}/events/': {
      id: '/{-$locale}/events/'
      path: '/{-$locale}/events'
      fullPath: '/{-$locale}/events/'
      preLoaderRoute: typeof Char123LocaleChar125EventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/{-$locale}/articles/': {
      id: '/{-$locale}/articles/'
      path: '/{-$locale}/articles'
      fullPath: '/{-$locale}/articles/'
      preLoaderRoute: typeof Char123LocaleChar125ArticlesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/{-$locale}/job-offers/$id': {
      id: '/{-$locale}/job-offers/$id'
      path: '/$id'
      fullPath: '/{-$locale}/job-offers/$id'
      preLoaderRoute: typeof Char123LocaleChar125JobOffersIdRouteImport
      parentRoute: typeof Char123LocaleChar125JobOffersRouteRoute
    }
    '/{-$locale}/internships/$id': {
      id: '/{-$locale}/internships/$id'
      path: '/$id'
      fullPath: '/{-$locale}/internships/$id'
      preLoaderRoute: typeof Char123LocaleChar125InternshipsIdRouteImport
      parentRoute: typeof Char123LocaleChar125InternshipsRouteRoute
    }
  }
}

interface Char123LocaleChar125InternshipsRouteRouteChildren {
  Char123LocaleChar125InternshipsIdRoute: typeof Char123LocaleChar125InternshipsIdRoute
  Char123LocaleChar125InternshipsIndexRoute: typeof Char123LocaleChar125InternshipsIndexRoute
}

const Char123LocaleChar125InternshipsRouteRouteChildren: Char123LocaleChar125InternshipsRouteRouteChildren =
  {
    Char123LocaleChar125InternshipsIdRoute:
      Char123LocaleChar125InternshipsIdRoute,
    Char123LocaleChar125InternshipsIndexRoute:
      Char123LocaleChar125InternshipsIndexRoute,
  }

const Char123LocaleChar125InternshipsRouteRouteWithChildren =
  Char123LocaleChar125InternshipsRouteRoute._addFileChildren(
    Char123LocaleChar125InternshipsRouteRouteChildren,
  )

interface Char123LocaleChar125JobOffersRouteRouteChildren {
  Char123LocaleChar125JobOffersIdRoute: typeof Char123LocaleChar125JobOffersIdRoute
  Char123LocaleChar125JobOffersIndexRoute: typeof Char123LocaleChar125JobOffersIndexRoute
}

const Char123LocaleChar125JobOffersRouteRouteChildren: Char123LocaleChar125JobOffersRouteRouteChildren =
  {
    Char123LocaleChar125JobOffersIdRoute: Char123LocaleChar125JobOffersIdRoute,
    Char123LocaleChar125JobOffersIndexRoute:
      Char123LocaleChar125JobOffersIndexRoute,
  }

const Char123LocaleChar125JobOffersRouteRouteWithChildren =
  Char123LocaleChar125JobOffersRouteRoute._addFileChildren(
    Char123LocaleChar125JobOffersRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  Char123LocaleChar125InternshipsRouteRoute:
    Char123LocaleChar125InternshipsRouteRouteWithChildren,
  Char123LocaleChar125JobOffersRouteRoute:
    Char123LocaleChar125JobOffersRouteRouteWithChildren,
  Char123LocaleChar125IndexRoute: Char123LocaleChar125IndexRoute,
  Char123LocaleChar125ArticlesIndexRoute:
    Char123LocaleChar125ArticlesIndexRoute,
  Char123LocaleChar125EventsIndexRoute: Char123LocaleChar125EventsIndexRoute,
  Char123LocaleChar125HospitalsIndexRoute:
    Char123LocaleChar125HospitalsIndexRoute,
  Char123LocaleChar125RatingsIndexRoute: Char123LocaleChar125RatingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
